import { parseHash, parseSearch } from '@autopass-web/domain';

import { PATH } from '../config';
import repo from '../service/repository';

export const login = (success, failure, additionalFetch = []) => {
  return Promise.all([
    repo.fetchUserInfo(),
    repo.fetchLicensePlates(),
    repo.fetchParkingRecord(),
    repo.fetchOrders({ transactionTypes: ['refueling'] }),
    repo.fetchOrders({ transactionTypes: ['parking'] }),
    ...additionalFetch,
  ])
    .then(async (result) => {
      for (const data of result) {
        if (data.error) throw data.error;
      }

      const payload = {
        me: result[0].data,
        licensePlates: result[1].data,
        parkingRecord: result[2].data,
        orders: {
          refueling: result[3].data.data,
          parking: result[4].data.data,
        },
      };

      return await success(payload);
    })
    .catch((e) => {
      console.log(e);
      return failure(e);
    });
};

export const checkCreditCardBinding = async (get) => {
  if (window.location.hash !== '') {
    const hashData = parseHash(window.location.hash);
    const searchData = parseSearch(window.location.search);

    const errorView = (errorMessage) => {
      get().showFailMessage(errorMessage);
      if (searchData.nextLink === PATH.USER_STREET_PARKING_AUTOPAY_NOTICE) {
        return { path: PATH.USER_BIND_CARD, paymentBindingFail: true };
      }
      return { path: PATH.PAYMENT };
    };

    // result 代表這次綁卡成功與否 success: 成功, fail 失敗
    if (hashData['result'] === 'success') {
      const { error } = await repo.bindMochipayWallet({
        token: hashData['token'],
        transactionId: hashData['merchant_transaction_id'],
      });

      if (error) return errorView(error);

      const { error: userError, data: userData } = await repo.fetchUserInfo();
      if (userError) throw userError;
      get().updateUser(userData);
      get().showSuccessMessage('卡片新增成功');

      if (!searchData.nextLink) {
        return { path: PATH.PAYMENT };
      } else {
        if (searchData.nextLink === PATH.STREET_PARKING_AUTOPAY) {
          const { data } = await repo.toggleStreetParkingAutopay(true);
          if (data) get().updateUser(data);
          return { path: PATH.STREET_PARKING_AUTOPAY };
        } else {
          return { path: searchData.nextLink };
        }
      }
    } else {
      return errorView(hashData.message);
    }
  } else {
    return { path: '' };
  }
};
